import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Perdés tiempo valioso buscando material nuclear que casi nunca tiene ejemplos argentinos', 'Tus alumnos se desconectan porque los ejemplos son de Chernóbil sin contexto o de centrales que no tienen nada que ver con Argentina', 'No sabés cómo conectar la energía nuclear con la actualidad del país: el CAREM-25, Atucha II, el Tc-99m de Ezeiza, INVAP exportando reactores al mundo', 'Cada vez que querés enseñar los accidentes nucleares terminás generando más miedo del que había, porque no tenés los datos reales para equilibrar el relato', 'Tus evaluaciones siempre son las mismas porque no tenés un banco de ejercicios de decaimiento radiactivo, balanceo de reacciones y cálculos de producción actualizado', 'Cuando llega el inicio del ciclo lectivo no tenés armada una secuencia didáctica completa que vincule la física nuclear con la soberanía tecnológica argentina', 'No tenés claridad sobre cómo enseñar la diferencia entre un reactor y una bomba de forma que el alumno lo entienda sin volver a confundirlo', 'Querés enseñar el CAREM-25 pero no encontrás un recurso integrado, en español y con foco en lo que Argentina está haciendo hoy', 'Sentís que el nivel de tus clases no está a la altura de lo que tus alumnos merecen cuando Argentina es el único país latinoamericano que diseña y exporta reactores nucleares al mundo'];
  return <section className="py-20 bg-base" data-id="element-229">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-231">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-232">
            ❓ ¿Cuántas clases más vas a preparar sobre energía nuclear sin
            tener el material correcto?
          </h2>

          <div className="space-y-6 text-lg text-muted text-left md:text-center max-w-3xl mx-auto" data-id="element-233">
            <p className="text-[14px]" data-id="element-234">
              Tal vez ya buscaste información nuclear en YouTube que no tiene
              secuencia didáctica ni menciona Argentina. Tal vez armás tus
              propias planificaciones desde cero cada ciclo lectivo. Tal vez
              cuando un alumno pregunta sobre el CAREM-25, sobre Chernóbil,
              sobre por qué Argentina exporta reactores o sobre qué hace el
              reactor de Ezeiza con el cáncer de tiroides, no tenés una
              respuesta que los enganche con la realidad del país.
            </p>
            <p data-id="element-235">
              <strong className="text-white" data-id="element-236">
                No es falta de vocación docente. Es que nadie armó el sistema
                completo para vos.
              </strong>
            </p>
            <p className="font-bold text-white pt-4 text-[16px] pl-[10px]" data-id="element-237">
              😓 Esto te está pasando ahora mismo
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/50 rounded-2xl p-6 md:p-8" data-id="element-238">
          <ul className="space-y-4" data-id="element-239">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-240">
                <div className="mt-1 bg-red-900/50 p-1 rounded-full shrink-0" data-id="element-241">
                  <X className="w-4 h-4 text-red-400" data-id="element-242" />
                </div>
                <span className="text-muted font-medium" data-id="element-243">{problem}</span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-244">
          <p className="font-bold text-electric text-[18px]" data-id="element-245">
            ¿Y si esta fuera la última semana que enseñás Energía Nuclear sin
            tener todo el material resuelto?
          </p>
        </div>
      </div>
    </section>;
}